class CurrencyConverter {
  constructor() {
    this.rates = {
      'EUR': 1,
      'PLN': 4.30,
      'USD': 1.08,
    };
    this.currentCurrency = 'EUR';
    this.originalPrices = new Map();
    this.isInitialized = false;
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    console.log('Currency Converter: Initializing...');
    
    this.createSwitcher();
    this.findAndSaveOriginalPrices();
    
    const savedCurrency = localStorage.getItem('selectedCurrency');
    if (savedCurrency && savedCurrency !== 'EUR' && this.rates[savedCurrency]) {
      this.currentCurrency = savedCurrency;
      this.updateSelectorValue();
      this.convertPrices();
    }
    
    this.attachEventListeners();
    this.observePriceChanges();
    this.isInitialized = true;
    
    console.log('Currency Converter: Ready!');
  }

  createSwitcher() {
    const oldSwitcher = document.getElementById('currency-selector');
    if (oldSwitcher) {
      oldSwitcher.parentElement.remove();
    }

    const switcher = document.createElement('div');
    switcher.className = 'currency-switcher';
    switcher.style.cssText = 'display: inline-block; margin: 0 15px; padding: 5px;';
    switcher.innerHTML = `
      <select id="currency-selector" class="currency-select" style="padding: 8px 12px; font-size: 14px; border: 1px solid #ddd; border-radius: 4px; cursor: pointer;">
        ${Object.keys(this.rates).map(currency => 
          `<option value="${currency}">${currency}</option>`
        ).join('')}
      </select>
    `;
    
    const targets = [
      document.querySelector('.header__icons'),
      document.querySelector('.header-wrapper'),
      document.querySelector('header nav'),
      document.querySelector('header'),
      document.body
    ];

    for (let target of targets) {
      if (target) {
        console.log('Inserting switcher into:', target.className || target.tagName);
        target.appendChild(switcher);
        break;
      }
    }
  }

  updateSelectorValue() {
    const selector = document.getElementById('currency-selector');
    if (selector) {
      selector.value = this.currentCurrency;
    }
  }

  findAndSaveOriginalPrices() {
  const allElements = document.querySelectorAll('*');
  let foundCount = 0;
  
  allElements.forEach(element => {
    // Пропускаем элементы, которые уже обработаны
    if (this.originalPrices.has(element)) return;
    if (element.children.length > 0) return;
    
    const text = element.textContent.trim();
    
    // ВАЖНО: Ищем ТОЛЬКО EUR цены (оригинальные)
    const patterns = [
      /(\d+(?:\.\d{3})*,\d{2})\s*EUR\s*-?\s*Net/i,  // 1.150,00 EUR - Net
      /(\d+,\d{2})\s*EUR\s*-?\s*Net/i,              // 150,00 EUR - Net
      /(\d+(?:\.\d{3})*,\d{2})\s*EUR/i,             // 1.150,00 EUR
      /(\d+,\d{2})\s*EUR/i                          // 150,00 EUR
    ];
    
    for (let pattern of patterns) {
      const match = text.match(pattern);
      if (match) {
        // Убираем точки (разделители тысяч) и заменяем запятую на точку
        let priceStr = match[1].replace(/\./g, '').replace(',', '.');
        let price = parseFloat(priceStr);
        
        if (!isNaN(price) && price > 0) {
          let priceType = 'default';
          if (text.match(/Net/i)) {
            priceType = 'net';
          }
          
          // Сохраняем только если это EUR цена
          if (text.includes('EUR')) {
            this.originalPrices.set(element, {
              price: price,
              type: priceType
            });
            foundCount++;
            break;
          }
        }
      }
    }
  });
  
  console.log('Found EUR prices:', foundCount, 'Total stored:', this.originalPrices.size);
}



  attachEventListeners() {
    const selector = document.getElementById('currency-selector');
    if (selector) {
      selector.addEventListener('change', (e) => {
        const newCurrency = e.target.value;
        console.log('Currency changed to:', newCurrency);
        
        this.currentCurrency = newCurrency;
        localStorage.setItem('selectedCurrency', newCurrency);
        
        if (newCurrency === 'EUR') {
          this.restoreOriginalPrices();
        } else {
          this.convertPrices();
        }
      });
      console.log('Event listener attached');
    } else {
      console.error('Currency selector not found!');
    }
  }

  restoreOriginalPrices() {
    let restoredCount = 0;
    
    this.originalPrices.forEach((data, element) => {
      const formattedPrice = this.formatPrice(data.price);
      
      if (data.type === 'net') {
        element.textContent = `${formattedPrice} EUR - Net`;
      } else {
        element.textContent = `${formattedPrice} EUR`;
      }
      restoredCount++;
    });
    
    console.log('Restored EUR prices:', restoredCount);
  }

  convertPrices() {
    let convertedCount = 0;
    
    this.originalPrices.forEach((data, element) => {
      const convertedPrice = this.convert(data.price);
      const formattedPrice = this.formatPrice(convertedPrice);
      
      if (data.type === 'net') {
        element.textContent = `${formattedPrice} ${this.currentCurrency} - Net`;
      } else {
        element.textContent = `${formattedPrice} ${this.currentCurrency}`;
      }
      convertedCount++;
    });
    
    console.log('Converted prices to', this.currentCurrency + ':', convertedCount);
  }

  convert(amount) {
    return this.currentCurrency === 'EUR' ? amount : amount * this.rates[this.currentCurrency];
  }

  formatPrice(price) {
  // Форматируем с разделителем тысяч (точка) и десятичным разделителем (запятая)
  return price.toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}


  observePriceChanges() {
    let timeout;
    const observer = new MutationObserver((mutations) => {
      const switcherChanged = mutations.some(mutation => {
        return Array.from(mutation.addedNodes).some(node => 
          node.id === 'currency-selector' || 
          (node.querySelector && node.querySelector('#currency-selector'))
        );
      });
      
      if (switcherChanged) return;
      
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const oldSize = this.originalPrices.size;
        this.findAndSaveOriginalPrices();
        const newSize = this.originalPrices.size;
        
        if (newSize > oldSize) {
          console.log('Found', (newSize - oldSize), 'new prices');
          if (this.currentCurrency !== 'EUR') {
            this.convertPrices();
          }
        }
      }, 100); // Уменьшил задержку с 300 до 100мс для более быстрой реакции
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    console.log('Mutation observer started');
  }
}

if (!window.currencyConverter) {
  window.currencyConverter = new CurrencyConverter();
}
